import { fetchWithAcceptHeaders } from '../utils/flowBuilderGridFetch';
import { resolvePublicUrl } from '../utils/publicUrl';
let cached;
let loadPromise = null;
export function normalizeAgencyNameKey(name) {
    return name.trim().toLowerCase().replace(/\s+/g, ' ');
}
/**
 * Resolve logo filename for an agency, or `null` to fall back to the MUI icon.
 * Checks `name`, then optional `agencyGroup` (grid bureau / parent label), so grouped tiles can match on the group title.
 */
export function resolveAgencyLogoFile(map, agency) {
    const rid = agency.recordId?.trim();
    if (rid && map.byRecordId?.[rid]) {
        const f = map.byRecordId[rid].trim();
        return f || null;
    }
    const nameKey = normalizeAgencyNameKey(agency.name);
    const groupKey = agency.agencyGroup?.trim()
        ? normalizeAgencyNameKey(agency.agencyGroup)
        : '';
    const exactCandidates = groupKey ? [nameKey, groupKey] : [nameKey];
    for (const exact of exactCandidates) {
        if (map.byExactName?.[exact]) {
            const f = map.byExactName[exact].trim();
            return f || null;
        }
    }
    const haystacks = groupKey ? [nameKey, groupKey] : [nameKey];
    for (const row of map.byNameContains ?? []) {
        const needle = row.match.trim().toLowerCase();
        if (!needle)
            continue;
        for (const haystack of haystacks) {
            if (haystack.includes(needle))
                return row.file.trim();
        }
    }
    return null;
}
/** Full URL for `<img src>` — uses app base path for virtual directories. */
export function resolveAgencyLogoPublicUrl(map, filename) {
    const base = map.basePath.replace(/\/$/, '');
    const path = `${base}/${filename}`;
    return resolvePublicUrl(path);
}
export async function loadAgencyLogoMap() {
    if (cached !== undefined)
        return cached;
    if (!loadPromise) {
        loadPromise = (async () => {
            try {
                const raw = resolvePublicUrl('/images/WV/agency-logo-map.json');
                const url = raw ?? '/images/WV/agency-logo-map.json';
                const res = await fetchWithAcceptHeaders(url, { cache: 'no-store' });
                if (!res.ok)
                    return null;
                const json = (await res.json());
                if (!json?.basePath)
                    return null;
                if (!Array.isArray(json.byNameContains))
                    json.byNameContains = [];
                if (!json.byRecordId)
                    json.byRecordId = {};
                if (!json.byExactName)
                    json.byExactName = {};
                return json;
            }
            catch {
                return null;
            }
        })();
    }
    const result = await loadPromise;
    cached = result;
    return result;
}
/** Testing / hot reload */
export function clearAgencyLogoMapCache() {
    cached = undefined;
    loadPromise = null;
}
